import { mapState, mapGetters, mapActions } from 'vuex'
// import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
// import Utility from '@/utils/Utility'

export default {
  name: 'NoticeCheck',
  // components: {
  //   Loading
  // },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {

    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.noticeCheck.categoryName,
    }),
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
    }),
    
    init () {

    }
  }
}